import Service from "../../../Services/index";

const driver = {
    namespaced: true,
    state: {
        driverList: [],
        optionDriver: [],
        optionDriverInvoice: [],
        form: {
            id: '',
            first_name: '',
            last_name: '',
            id_card: '',
            license_plate: '',
            key: '',
            transport_type_id: null,
            phone: '',
            phone2: '',
            phone3: '',
            register_home_file: '',
            id_card_file: '',
            contract_file: '',
            insurance_fee_total: null,
            car_fee_total: null,
            withdraw_total: null,
            deposit_total: null,
            user_id: null,
            name_henchman_1: null,
            name_henchman_2: null,
            name_henchman_3: null,
            photo_henchman_1: null,
            photo_henchman_2: null,
            photo_henchman_3: null,
            car_act_date: null,
            tax_date: null,
            insurance_date: null,
            image_roof_fee: [],
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
        search: {
            transport_type: "",
            driver_id: "",
            date: [],
            driver: null,
        },
        setting_tax: {
            percent_tax: 1,
            is_auto: 0,
        }
    },
    mutations: {
        SET_DRIVER_LIST: (state, res) => {
            state.driverList = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.from,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            }
        },
        SET_DRIVER_ALL: (state, data) => {
            state.optionDriver = data;
        },
        SET_DRIVER_FROM_INVOICE: (state, res) => {
            state.optionDriverInvoice = res;
        },
        SET_FORM_DRIVER: (state, data) => {
            state.form = data;
        },
        CLEAR_FORM_DRIVER: (state) => {
            state.form = {
                id: '',
                first_name: '',
                last_name: '',
                id_card: '',
                license_plate: '',
                key: '',
                transport_type_id: null,
                phone: '',
                phone2: '',
                phone3: '',
                register_home_file: '',
                id_card_file: '',
                contract_file: '',
                insurance_fee_total: null,
                car_fee_total: null,
                withdraw_total: null,
                deposit_total: null,
                user_id: null,
                name_henchman_1: null,
                name_henchman_2: null,
                name_henchman_3: null,
                photo_henchman_1: null,
                photo_henchman_2: null,
                photo_henchman_3: null,
                car_act_date: null,
                tax_date: null,
                insurance_date: null,
                image_roof_fee: [],
            }
        },
        ADD_PHONE: (state, data) => {
            state.form.phone.push(data);
        },
        REMOVE_PHONE: (state, index) => {
            state.form.phone = state.form.phone.filter(
                (phone, itemIndex) => index !== itemIndex
            );
        },
        CLEAR_SEARCH: (state) => {
            state.search = {
                transport_type: "",
                driver_id: "",
                driver: '',
                date: [],
            }
        },
        CLEAR_DETAILS: (state) => {
            state.form = {
                id: '',
                first_name: '',
                last_name: '',
                id_card: '',
                license_plate: '',
                key: '',
                transport_type_id: null,
                phone: '',
                phone2: '',
                phone3: '',
                register_home_file: '',
                id_card_file: '',
                contract_file: '',
                insurance_fee_total: null,
                car_fee_total: null,
                withdraw_total: null,
                deposit_total: null,
                user_id: null,
                name_henchman_1: null,
                name_henchman_2: null,
                name_henchman_3: null,
                photo_henchman_1: null,
                photo_henchman_2: null,
                photo_henchman_3: null,
                car_act_date: null,
                tax_date: null,
                insurance_date: null,
                image_roof_fee: [],
            }
        },
        SETTING_TAX_DRIVER: (state, res) => {
            //console.log(res)
            //console.log(state)
            if (state.form.transport_type_id == 1 || state.form.transport_type_id == 2) {
                if (res) {
                    state.setting_tax = {
                        percent_tax: res.percent_tax,
                        is_auto: 0,
                    }
                } else {
                    state.setting_tax = {
                        percent_tax: 1,
                        is_auto: 0,
                    }
                }
            } else {
                if (res) {
                    state.setting_tax = res;
                } else {
                    state.setting_tax = {
                        percent_tax: 1,
                        is_auto: 1,
                    }
                }
            }
        }
    },
    actions: {
        setDriver({commit}, page = 1) {
            return Service.Driver.getDriver(page).then(data => {
                commit("SET_DRIVER_LIST", data);
            });
        },
        getAll({commit}) {
            return Service.Driver.getDriverAll().then(data => {
                commit("SET_DRIVER_ALL", data);
                commit("SET_DRIVER_FROM_INVOICE", data);
            });
        },
        show({commit}, id) {
            return Service.Driver.showDriver(id).then(data => {
                commit("SET_FORM_DRIVER", data);
            });
        },
        save({commit, state}, {id, data}) {
            if (!id) {
                //create
                return Service.Driver.createDriver(data);
            } else {
                return Service.Driver.updateDriver(id, data);
            }
        },
        delete({commit}, {id, data}) {
            return Service.Driver.deleteDriver(id, data);
        },
        search({commit}, {page = 1, data}) {
            return Service.Driver.searchDriver(page, data)
                .then(data => {
                    commit("SET_DRIVER_LIST", data)
                })
        },
        clearform({commit}) {
            commit("CLEAR_FORM_DRIVER");
        },
        addPhone({commit}, data) {
            commit("ADD_PHONE", data);
        },
        removePhone({commit}, index) {
            commit("REMOVE_PHONE", index);
        },
        clearSearch({commit}) {
            commit("CLEAR_SEARCH");
        },
        clearDriver({commit}) {
            commit("CLEAR_DETAILS");
        },

        //form invoice
        getDriverFromInvoice({commit}, transport_type_id) {
            return Service.Driver.getDriverFromInvoice(transport_type_id).then(res => {
                commit("SET_DRIVER_FROM_INVOICE", res);
            })
        },
        getDriverBigCar({commit}, search) {
            return Service.Driver.getDriverBigCar(search.page, search.driver_name).then(res => {
                commit('SET_DRIVER_LIST', res)
            });
        },
        /*update 5/5/2020*/
        getDriverById({commit}, id) {
            return Service.Driver.getDriverById(id).then(res => {
                commit('CLEAR_FORM_DRIVER')
                commit('SET_FORM_DRIVER', res)
            })
        },
        /*update 25/11/2020*/
        saveSettingTax({commit}, data) {
            return Service.Driver.updateSettingTaxAuto(data);
        },
        getSettingTax({commit}) {
            return Service.Driver.showSettingTaxAuto().then(res => {
                commit('SETTING_TAX_DRIVER', res);
            });
        },
        onePercent({commit}, data) {
            return Service.Driver.onePercent(data);
        },
        transportSale({commit}, data) {
            return Service.Driver.transportSale(data);
        },
        getRemaining({commit}, id) {
            return Service.Driver.getRemaining(id);
        }
    }
};
export default driver;
